function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

import { isEmptyObject } from '../../tools/utils/objectUtils';
import { objectEntries } from '../../tools/utils/polyfills';
import { dateNow } from '../../tools/utils/timeUtils';
import { generateUUID } from '../../tools/utils/stringUtils';
import { SESSION_EXPIRATION_DELAY, SESSION_TIME_OUT_DELAY } from './sessionConstants';
import { isValidSessionString, SESSION_ENTRY_REGEXP, SESSION_ENTRY_SEPARATOR } from './sessionStateValidation';
export var EXPIRED = '1';
export function getExpiredSessionState(previousSessionState, configuration) {
  var expiredSessionState = {
    isExpired: EXPIRED
  };

  if (configuration.trackAnonymousUser) {
    if (previousSessionState === null || previousSessionState === void 0 ? void 0 : previousSessionState.anonymousId) {
      expiredSessionState.anonymousId = previousSessionState === null || previousSessionState === void 0 ? void 0 : previousSessionState.anonymousId;
    } else {
      expiredSessionState.anonymousId = generateUUID();
    }
  }

  return expiredSessionState;
}
export function isSessionInNotStartedState(session) {
  return isEmptyObject(session);
}
export function isSessionStarted(session) {
  return !isSessionInNotStartedState(session);
}
export function isSessionInExpiredState(session) {
  return session.isExpired !== undefined || !isActiveSession(session);
} // An active session is a session in either `Tracked` or `NotTracked` state

function isActiveSession(sessionState) {
  // created and expire can be undefined for versions which was not storing them
  // these checks could be removed when older versions will not be available/live anymore
  return (sessionState.created === undefined || dateNow() - Number(sessionState.created) < SESSION_TIME_OUT_DELAY) && (sessionState.expire === undefined || dateNow() < Number(sessionState.expire));
}

export function expandSessionState(session) {
  session.expire = String(dateNow() + SESSION_EXPIRATION_DELAY);
}
export function toSessionString(session) {
  return objectEntries(session) // we use `aid` as a key for anonymousId
  .map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return key === 'anonymousId' ? "aid=".concat(value) : "".concat(key, "=").concat(value);
  }).join(SESSION_ENTRY_SEPARATOR);
}
export function toSessionState(sessionString) {
  var session = {};

  if (isValidSessionString(sessionString)) {
    sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
      var matches = SESSION_ENTRY_REGEXP.exec(entry);

      if (matches !== null) {
        var _matches = _slicedToArray(matches, 3),
            key = _matches[1],
            value = _matches[2];

        if (key === 'aid') {
          // we use `aid` as a key for anonymousId
          session.anonymousId = value;
        } else {
          session[key] = value;
        }
      }
    });
  }

  return session;
}